import config from 'config.json';
import './tablero.scss';
import template from './tablero.html';
import commonI18N from 'i18n/common/es.json';
import turnosI18N from 'i18n/turnos/es.json';
import { rest } from 'core/api';
import { fullscreen } from 'core/util';
import especialistaTemplate from './especialista.html';
import { horaRenderer } from 'core/util';


// MODULE EXPORTS
export let TableroTurnosComponent = {
  templateUrl: template,
  selector: 'tableroTurnos',
  bindings: {
    translations: '='
  },
  controller: TableroCtrl,
  controllerAs: 'vm'
};

export const translationKeys = Object.keys(commonI18N).concat(turnosI18N);

TableroCtrl.$inject = ['$ngRedux', '$state', 'CustomModal', 'BasicFactory', '$timeout'];


function TableroCtrl($ngRedux, $state, CustomModal, BasicFactory, $timeout) {
  Object.assign(this, { $ngRedux, $state });
  this.mapStateToThis = mapStateToThis.bind(this);
  this.renderTurno = renderTurno.bind(this);
  this.especialistasDisponibles = especialistasDisponibles.bind(this);
  this.concretarTurno = concretarTurno.bind(this);
  this.renderEspecialista = renderEspecialista.bind(this);
  this.loadEspecialistasDisponibles = loadEspecialistasDisponibles.bind(this);
  this.filterEspecialistasDisponibles = filterEspecialistasDisponibles.bind(this);
  this.renderHora = renderHora.bind(this);

  this.fullscreen = () => { $timeout(() => fullscreen()); };

  this.localModel = {
    payload: {},
    day: moment().format('DD/MM/YYYY')
  };

  let unsubscribe;
  this.$onDestroy = () => {
    $ngRedux.dispatch(rest.actions.turnosPendientes.reset());
    unsubscribe();
    this.loading = false;
  };

  this.$onInit = () => {
    unsubscribe = $ngRedux.connect(this.mapStateToThis, {})(this);
    $ngRedux.dispatch(rest.actions.turnosPendientes());
    this.localModel.concretable = {};
    this.loading = this.loading === undefined ? true : false;
  };

  function mapStateToThis(state) {
    let self = this;
    if (!state.turnosPendientes.loading && state.turnosPendientes.data && state.turnosPendientes.data.length > 0 && !this.localModel.turnos) {
      let turnos = {};
      state.turnosPendientes.data.forEach(function(turno) {
        turnos[turno.id] = turno;
      });
      self.loading = false;
      self.sinResultados = false;
      self.localModel.turnos = turnos;
    }

    if (state.turnosPendientes.data && state.turnosPendientes.data.length === 0) {
      self.loading = false;
      self.sinResultados = true;
    }

    return {};
  }

  function renderTurno(turno) {
    return `${turno.turno.cliente.razonSocial}`;
  }

  function especialistasDisponibles(servicio, turnoId) {
    let self = this;

    self.localModel.payload.servicioId = servicio.id;

    self.localModel.modalOpen = true;

    // Resetear los especialistas disponibles cada vez que se abre el dlg de concrecion de un turno
    self.fetchedEspecialistasDisponibles = null;

    CustomModal.open({
      title: 'Concretar Turno',
      size: 'lg',
      templateUrl: especialistaTemplate,
      vm: self,
      servicio: servicio.nombre,
      servicioId: servicio.id,
      renderEspecialista,
      turnoId,
      fecha: this.localModel.day,
      payload: self.localModel.payload,
      actionLabel: 'Concretar',
      fieldsToShowEspecialista: ['nombre', 'apellido']
    });
  }

  /**
   * @param turnoId Id del turno cuyos especialistas disponibles se desea
   * @param query Filtro por nombre/apellido del especialista
   * @returns {Promise<unknown>|*} Lista de especialistas disponibles para un turno dado, filtrado por nombre del
   * especialista
   */
  function loadEspecialistasDisponibles(turnoId, query) {
    // Si ya se tienen los especialistas para este turno, filtrar de ahi nomas
    if (this.fetchedEspecialistasDisponibles) {
      return Promise.resolve(this.filterEspecialistasDisponibles(this.fetchedEspecialistasDisponibles, query));
    } else {
      //Si no primero traer, guardar, y filtrar por el query
      BasicFactory.setup('turnos/especialistas-disponibles');
      return BasicFactory
        .all({day: this.localModel.day, turnoId})
        .then(response => {
          this.fetchedEspecialistasDisponibles = response && response.especialistasDisponibles;
          return this.filterEspecialistasDisponibles(this.fetchedEspecialistasDisponibles);
        });
    }
  }

  function filterEspecialistasDisponibles(especialistasDisponibles, query) {
    return (especialistasDisponibles || []).filter(e => {
      const nombre = `${e.nombre} ${e.apellido}`.toLowerCase();
      return !query || nombre.includes(query);
    });
  }

  function concretarTurno(turnoId, cancel) {
    let self = this;
    $ngRedux.dispatch(rest.actions.concretarTurno({ id: turnoId }, {
      body: JSON.stringify({especialistaId: this.localModel.payload.especialista.id})
    }, (err, data) => {
      if (!err && data) {

        self.localModel.turnos = null;
        self.localModel.especialistas = null;
        self.localModel.modalOpen = false;

        self.$ngRedux.dispatch(rest.actions.turnosPendientes());
        self.localModel.payload.especialista = null;
        self.loading = self.loading === undefined ? true : false;
        self.localModel.concretable = {};
        cancel();
      } else if (err) {
        console.log(err);
        //this.ngNotify.set(err.message, 'warn');
      }
    }));
  }

  function renderEspecialista(especialista) {
    return `${especialista.nombre} ${especialista.apellido}`;
  }

  function renderHora(hora) {
    return hora.split(' ')[1];
  }
}



// WEBPACK FOOTER //
// ./src/components/tablero-turnos/tablero.component.js